import { Box, Typography, styled } from "@mui/material";
import { colors } from "../../theme/colors";


export const PageMeta = styled(Typography)({
  fontSize: "14px",
  color: colors.text.secondary,
  fontFamily: "Nunito",
  marginBottom: "32px",
});

export const FormSection = styled(Box)({
  marginBottom: "32px",
});

export const FormRow = styled(Box)({
  display: "flex",
  gap: "24px",
  marginBottom: "24px",
});

export const SectionTitle = styled(Typography)({
  fontSize: "18px",
  fontWeight: 600,
  color: colors.text.primary,
  fontFamily: "Sora",
  marginBottom: "16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
});

export const StepsContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

export const DraggableAppointmentWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isDragging" && prop !== "isDragOver",
})<{
  isDragging?: boolean;
  isDragOver?: boolean;
}>(({ isDragging, isDragOver }) => ({
  border: `3px dashed ${isDragOver ? colors.primary.main : "transparent"}`,
  borderRadius: "16px",
  padding: "4px",
  backgroundColor: isDragOver ? colors.background.lightBlue : "transparent",
  opacity: isDragging ? 0.5 : 1,
  boxShadow: isDragging ? "0 8px 24px rgba(0,0,0,0.15)" : "none",
  transition:
    "border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease",
}));

export const FooterContainer = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  gap: "16px",
  marginTop: "32px",
});
